import { Modal } from 'components/ui';
import { useVendor } from 'features/vendor';
import { ShopForm } from './ShopForm';
import { addShopInitialValues } from '../utils/shopProfile';

/** Modal wrapping the ShopForm in "create" mode (registerNewShop: true). */
export function AddShopModal({ isOpen, onSubmit, submitting, onClose }) {
  const { profile } = useVendor();

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Add a new shop" size="xl">
      {isOpen && (
        <ShopForm
          // Prefill identity/branding from the active shop; location/timings blank.
          initialValues={addShopInitialValues(profile)}
          onSubmit={onSubmit}
          submitting={submitting}
          submitLabel="Create shop"
          isNew
        />
      )}
    </Modal>
  );
}

export default AddShopModal;
